<!-- <h3 class="header"> </h3> -->
<h2 class="title m-2">Previous Land Name <i class="ti-close pull-right" style="color: red; cursor: pointer;" (click)="onClose()"></i></h2>
<div class="check_rep">
  <button class="default_secondary-btn relatives m-2" (click)="addLandTitleName()">Add</button>
</div>
<table class="table table-hover" [formGroup]="landTitleNameForm">
  <thead>
    <tr>
      <th scope="col">S/N</th>
      <th scope="col">Land Name</th>
      <th scope="col">Land Remarks</th>
      <th scope="col">Action</th>
    </tr>
  </thead>
  <tbody formArrayName="LandTitleNames">
    <tr *ngFor="let landTitleName of landTitleNameForm.get('LandTitleNames')['controls']; index as i"
    [formGroupName]="i"
    >
      <th scope="row">{{i + 1}}</th>
      <td>
        <div class="the_input">
        <input type="text" formControlName="LandTitleName" class="default_input" />
      </div>
    </td>
      <td>
        <div class="the_input">
          <input type="text" formControlName="LandTitleRemarks" class="default_input" />
        </div>
      </td>
      <td>
        <i class="ti-trash" style="color: red; cursor: pointer; font-size: large;" (click)="onDelete(i)"></i>
      </td>
    </tr>

  </tbody>
</table>
<div class="acquisition_submit">
  <button class="default_primary-button" (click)="onSubmit(landTitleNameForm.value)" type="submit">
    Submit
  </button>
</div>
